import { render } from "./AuditLogPanel.vue?vue&type=template&id=3b77077e&scoped=true"
import script from "./AuditLogPanel.vue?vue&type=script&lang=js"
export * from "./AuditLogPanel.vue?vue&type=script&lang=js"

import "./AuditLogPanel.vue?vue&type=style&index=0&id=3b77077e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b77077e"]])

export default __exports__